<script setup>
import NavBar from "../components/NavBar.vue";
import { onMounted, onUpdated, inject } from "vue";
import { getCurrentShopConfig } from "../shopConfig";

const _shopConfig = getCurrentShopConfig();
const currentProductType = inject("currentProductType");

const props = defineProps({
  srcbild: { type: String, required: true },
  option: { type: Object },
  routeinfo: { type: Object },
  productType: { type: String },
});
onUpdated(() => {
  // getImageSizeToRoom();
});

function getImageSizeToRoom(option) {
  if (props.routeinfo.name === "produktansicht") {
    this.imgSize.removeAttribute("width");
    this.imgSize.removeAttribute("height");
    return;
  }

  if (props.option[_shopConfig.optionKeys.size] === undefined) {
    return;
  }

  setTimeout(() => {
    const roomSize = document.querySelector("img.bottom");
    const ration = props.option[_shopConfig.optionKeys.size].split("x");
    const imgSize = document.querySelector(".preview-area img.croppedImage");

    let imgSizeWidth =
      ((roomSize.naturalWidth - 120) / 200) * Number(ration[0]);
    let imgSizeHeight =
      ((roomSize.naturalWidth - 120) / 200) * Number(ration[1].slice(0, -2));

    if (imgSize.width > imgSize.height) {
      imgSizeHeight = ((roomSize.naturalWidth - 120) / 200) * Number(ration[0]);
      imgSizeWidth =
        ((roomSize.naturalWidth - 120) / 200) * Number(ration[1].slice(0, -2));
    }

    imgSize.width = imgSizeWidth;
    imgSize.height = imgSizeHeight;
  }, "500");
}
</script>

<template>
  <menu>
    <NavBar
      :srcbild="srcbild"
      :option="option"
      :type="currentProductType ?? _shopConfig.diamondPaintingProductId"
      :routeinfo="$route"
    />
  </menu>
</template>

<style>
menu {
  overflow: auto;
  margin-top: 10px;
  width: 355pt;
}
</style>
